import { render, staticRenderFns } from "./sendStatistics.vue?vue&type=template&id=28d94aa6&scoped=true&"
import script from "./sendStatistics.vue?vue&type=script&lang=js&"
export * from "./sendStatistics.vue?vue&type=script&lang=js&"
import style0 from "./sendStatistics.vue?vue&type=style&index=0&id=28d94aa6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28d94aa6",
  null
  
)

export default component.exports